import { useFrame, useThree } from "@react-three/fiber";
import * as THREE from "three";
import { useSnapshot } from "valtio";
import { stateOrbitLocation, statePlayerPositionS, statePlayerSwitch, stateIframeWindow } from "../store";
import { OrbitControls } from "@react-three/drei";
import { useRef, useEffect, useState } from "react";
import { usePlayerPosition } from "./PlayerPositionContext";

let diff = 0 


const CameraControls = ({}) => {

  const { camTarget } = usePlayerPosition();

  const snapOrbitCamera = useSnapshot(stateOrbitLocation);

  const cameraOrbitGoalPosition = snapOrbitCamera.CameraPos;
  const targetOrbitGoalPosition = snapOrbitCamera.TargetPos;
  const orbitClicked = snapOrbitCamera.orbitClicked;
  const shouldUpdate = snapOrbitCamera.shouldUpdate;
  const camera = useThree((state) => state.camera);
  const orbitRef = useRef();
  const initialCameraPosition = useRef(new THREE.Vector3());
  const orbitTargetPosition = useRef(new THREE.Vector3());
  const snapPlayerswitch = useSnapshot(statePlayerSwitch)
  const snapStateIframeWindow = useSnapshot(stateIframeWindow)
  const [orbitEnabled, setOrbitEnabled] = useState(true)
  const [orbitZoomEnabled, setOrbitZoomEnabled] = useState(true)
  const [panEnabled, setPanEnabled] = useState(true)
  
  
  useEffect(()=>{

    if(snapOrbitCamera.lerpRuns){
    setOrbitEnabled(false)
    setOrbitZoomEnabled(false)
    setPanEnabled(false)
  }
  else{
    setOrbitEnabled(true)
    setOrbitZoomEnabled(true)
    setPanEnabled(true)
  }
  },[snapOrbitCamera.lerpRuns])

  useEffect(()=>{

    if(snapStateIframeWindow.LowModelOrbit){
    setOrbitEnabled(false)
    setOrbitZoomEnabled(false)
    setPanEnabled(false)
  }
  else{
    setOrbitEnabled(true)
    setOrbitZoomEnabled(true)
    setPanEnabled(true)
  }
  },[snapStateIframeWindow.LowModelOrbit])


  useEffect(() => {

    if (orbitClicked ) {
      
      initialCameraPosition.current.copy(camera.position);
      orbitTargetPosition.current.copy(targetOrbitGoalPosition);
   orbitRef.current.target.copy(camTarget)
   stateOrbitLocation.lerpRuns = true
   statePlayerPositionS.playeractive = false;
    }
 
  }, [orbitClicked]);

  useFrame(({ scene }, delta) => {
    if (orbitClicked && shouldUpdate) {
      // Zeitbasierter Lerp-Faktor (z. B. 5 pro Sekunde)
      const lerpSpeed = 5;
  
      camera.position.lerp(cameraOrbitGoalPosition, 1 - Math.exp(-lerpSpeed * delta));
      orbitRef.current.target.lerp(targetOrbitGoalPosition, 1 - Math.exp(-lerpSpeed * delta));
  
      const diff = camera.position.clone().sub(cameraOrbitGoalPosition).length();
      if (diff < 0.5) {
        stateOrbitLocation.lerpRuns = false;
        stateOrbitLocation.shouldUpdate = false;
      }
  
    } else if (!orbitClicked && !shouldUpdate) {
      const lerpSpeed = 5;
  
      camera.position.lerp(initialCameraPosition.current, 1 - Math.exp(-lerpSpeed * delta));
      orbitRef.current.target.lerp(camTarget, 1 - Math.exp(-lerpSpeed * delta));
  
      const diff = camera.position.clone().sub(initialCameraPosition.current).length();
      if (diff < 0.5) {
        stateOrbitLocation.shouldUpdate = true;
        stateOrbitLocation.lerpRuns = false;
        statePlayerPositionS.playeractive = true;
      }
    }
  });

  return (
    <>
     {!snapPlayerswitch.charSwitchClicked &&  <OrbitControls rotateSpeed={0.6} dampingFactor={0.05} ref={orbitRef} target={orbitTargetPosition.current} 
     enableRotate={orbitEnabled} 
     enableZoom={orbitZoomEnabled} 
     enablePan={panEnabled} 
    //  maxPolarAngle = {Math.PI/2}  
     minDistance={3} 
     maxDistance={5000}  />}
    </>
  );
};

export default CameraControls;
